module.exports = __webpack_public_path__ + "img/mad_eye_moody.ae9ef671.jpg";